import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "title", "description", "detailHeading", "details", "form", "methodInput", "submitButton"]
  static values = {
    defaultTitle: { type: String, default: "확인" },
    defaultDetailHeading: { type: String, default: "변경사항" },
    defaultSubmitLabel: { type: String, default: "확인" }
  }

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this)
  }

  open(event) {
    event.preventDefault()

    const {
      confirmActionUrl,
      confirmMethod,
      confirmTitle,
      confirmDescription,
      confirmDetailHeading,
      confirmDetails,
      confirmSubmitLabel
    } = event.currentTarget.dataset

    this.formTarget.action = confirmActionUrl
    this.methodInputTarget.value = (confirmMethod || "patch").toLowerCase()
    this.titleTarget.textContent = confirmTitle || this.defaultTitleValue
    this.descriptionTarget.textContent = confirmDescription || ""
    this.detailHeadingTarget.textContent = confirmDetailHeading || this.defaultDetailHeadingValue
    this.submitButtonTarget.textContent = confirmSubmitLabel || this.defaultSubmitLabelValue
    this.renderDetails(confirmDetails)

    this.overlayTarget.style.display = "flex"
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.boundKeydown)
  }

  close() {
    this.overlayTarget.style.display = "none"
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.boundKeydown)
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  submit(event) {
    event.preventDefault()
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.style.opacity = "0.7"
    this.formTarget.requestSubmit()
  }

  renderDetails(rawDetails) {
    this.detailsTarget.innerHTML = ""

    const lines = (rawDetails || "")
      .split(/\\n|\n/)
      .map((line) => line.trim())
      .filter(Boolean)

    lines.forEach((line) => {
      const row = document.createElement("div")
      row.style.display = "flex"
      row.style.alignItems = "flex-start"
      row.style.gap = "10px"

      const bullet = document.createElement("span")
      bullet.textContent = "•"
      bullet.style.color = "#059669"
      bullet.style.fontSize = "16px"
      bullet.style.fontWeight = "700"
      bullet.style.lineHeight = "1.5"
      bullet.style.flexShrink = "0"

      const text = document.createElement("div")
      text.textContent = line
      text.style.fontSize = "14px"
      text.style.color = "#374151"
      text.style.lineHeight = "1.6"

      row.appendChild(bullet)
      row.appendChild(text)
      this.detailsTarget.appendChild(row)
    })
  }
}
